import { useSelector } from "react-redux"
import { Link } from "react-router-dom"

const ProductComponent = () => {

    const products = useSelector((state) => state.allProducts.products)

    const renderProducts = products.map((product) => {
        const { id, title, price, category, image } = product
        return (
            <div key={id}>
                <Link to={`/products/${id}`}>
                    <div className='ui link cards'>
                        <div className='card'>
                            <div className='image'>
                                <img src={image} alt={title} />
                            </div>
                            <div className='content'>
                                <div className='header'>{title}</div>
                                <div className='meta price'>{price}</div>
                                <div className='meta'>{category}</div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        )
    })

    return (
        <>{renderProducts}</>
    )
}
export default ProductComponent